import get from 'lodash/get'
import isNil from 'lodash/isNil'
import omitBy from 'lodash/omitBy'
import round from 'lodash/round'

const removeFalsey = obj =>
  omitBy(obj, (val, key) => isNil(val) || (Array.isArray(get(obj, key)) && !val.length))

export const pickWithDefaults = (data, defaults) => {
  return {
    ...defaults,
    ...removeFalsey(data),
  }
}

export const roundTo100sPlace = num => Math.round(num * 100) / 100

export const fractionToPercent = fraction => round(fraction * 100, 1)

export const decodeBase64 = (base64String) => JSON.parse(atob(base64String))


// WEBPACK FOOTER //
// ./src/utils/data/index.js